<template>
  <div class="main">
    <div class="background">
      <img class="background-image cloud-l" src="../assets/course/cloud_left.png" alt="">
      <img class="background-image cloud-r" src="../assets/course/cloud_right.png" alt="">
      <div class="book-index container-fluid">
        <div class="row">
          <!-- Profile Section -->
          <div class="title-book row align-items-center">
            <div class="col-lg-5">
              <div class="d-flex flex-column align-items-center">
                <input type="file" @change="uploadImage" style="display: none" ref="fileInput">
                <div class="image-circle">
                  <img class="circle_picture" :src="imageSrc" />
                  <img class="editor pointer" src="../assets/book/changePhoto_btn_a.png" alt="" @click="openFileInput">
                </div>
              </div>
            </div>
            <div class="col-lg-1 my-2"></div>
            <div class="studentInfo col-lg-6">
              <div class="d-flex flex-column ">
                <h3 class="mb-3"><span class="user-name">{{user.name}} </span><span class="role-text">({{ userRole }})</span></h3>
                <p><span class="time-title">Login Times: </span><span class="time-text">{{user.login_times}}</span></p>
                <p><span class="time-title">Recent Login: </span><span class="time-text">{{moment(user.last_login_at).format('YYYY/MM/DD')}}</span></p>
                <p><span class="time-title">First Login: </span><span class="time-text">{{moment(user.first_login_at).format('YYYY/MM/DD')}}</span></p>
              </div>
            </div>
          </div>
          <!-- Book Items (Completed and Incomplete) -->
          <div v-for="(item, index) in books" :key="'book-' + index" class="col-sm-12 col-md-6 col-lg-4">
            <div v-if="item.percentage === 100">
              <div class="pointer book" @click="goPage(item)">
                <img class="book-frame" src="../assets/book/index_bookBtn01.png" alt="">
                <img class="book-image" :src="item.cover" alt="">
                <div class="name-box">
                  <p class="book-name">{{ item.title }}</p>
                </div>
              </div>
              <button type="button" @click="download(item)" class="btn btn-warning mb-2 mr-2">download</button>
              <button type="button" @click="print(item)" class="btn btn-warning mb-2">print</button>
              <ul class="book-detail">
                <li><label>Date: {{ moment(item.created_at).format('YYYY/MM/DD') }}</label></li>
                <li v-if="item.level"><label>Stage: {{ item.level }}</label></li>
                <li v-if="item.pages"><label>Pages: {{ item.pages }}</label></li>
                <li v-if="item.word_count"><label>Word Count: {{ item.word_count }}</label></li>
              </ul>
            </div>
            <div v-else-if="item.created_at === null" :key="index">
              <div class="pointer book" @click="modifyAiBook(item)">
                <img class="book-frame" src="../assets/book/index_bookBtn02.png" alt="">
                <img class="no-book-image" src="../assets/book/ai_help01_icon_01.png" alt="">
              </div>
            </div>
            <div v-else>
              <div class="pointer book" @click="modifyAiBook(item)">
                <img class="book-frame" src="../assets/book/index_bookBtn02.png" alt="">
                <div class="percentage">{{ item.percentage }} %</div>
              </div>
              <button type="button" disabled class="btn btn-warning mb-2 mr-2">download</button>
              <button type="button" disabled class="btn btn-warning mb-2">print</button>
              <ul class="book-detail">
                <li><label>Date: {{ moment(item.created_at).format('YYYY/MM/DD') }}</label></li>
                <li v-if="item.level"><label>Stage: {{ item.level }}</label></li>
                <li v-if="item.pages"><label>Pages: {{ item.pages }}</label></li>
                <li v-if="item.word_count"><label>Word Count: {{ item.word_count }}</label></li>
              </ul>
            </div>
          </div>
          <!-- Additional Book Slots (perTimes) -->
          <!-- eslint-disable-next-line -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import { mapGetters, mapActions } from 'vuex'
import api from '../store/api'

export default {
  name: 'AI-book',
  data () {
    return {
      imageSrc: '',
      books: {},
      user: {},
      monthPerTimes: 0
    }
  },
  props: {
    assistData: {
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    userRole () {
      switch (this.userInfo.role) {
        case 'user':
          return 'Student'
        default:
          return 'Teacher'
      }
    },
    perTimes () {
      if (this.books.length > 0) {
        return this.monthPerTimes - this.books.length
      } else {
        return this.monthPerTimes
      }
    }
  },
  mounted () {
    this.getBookIndex()
    this.getPersonalData()
    // this.getLoginCount()
    // if (this.authorized) {
    //   this.$router.push({ name: 'Search' })
    // }
  },
  methods: {
    ...mapActions({
      getUser: 'getUser'
    }),
    async getBookIndex () {
      const { data } = await api.get(`AIStorybook?page=1&pageSize=1000&student_id=${this.userInfo.student_id}`)
      this.books = data.data
      this.monthPerTimes = data.monthPerTimes
      this.user = data.user
      this.imageSrc = this.user.avatar
    },
    createAiBook () {
      this.$router.push({ name: 'Create_Book' })
    },
    modifyAiBook (item) {
      this.$router.push({ name: 'Modify_Book', params: { bookId: item.view_id } })
    },
    goPage (item) {
      // console.log(item)
      this.$router.push({ name: 'Book', params: { bookId: item.view_id } })
    },
    getPersonalData () {
      // this.getTarget(this.userInfo.student_id)
      this.imageSrc = this.userInfo.avatar
    },
    openFileInput () {
      this.$refs.fileInput.click()
    },
    download (el) {
      window.open(`https://ll-livespeaking.liveabc.com/AIStorybook/reader/${el.view_id}/download`, '_blank')
    },
    print (el) {
      const token = this.userInfo && this.userInfo.token ? this.userInfo.token : ''
      const url = `https://ll-livespeaking.liveabc.com/AIStorybook/reader/${el.view_id}/download/pdf?token=${encodeURIComponent(token)}`
      window.open(url, '_blank')
    },
    uploadImage (event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = () => {
          this.imageSrc = reader.result
          this.updatedAvatar(file)
        }
        reader.readAsDataURL(file)
      }
    },
    async updatedAvatar (file) {
      const fileData = new window.FormData()
      fileData.append('file', file)
      await api.post('update_avatar', fileData)
      await this.getUser()
    }
  },
  components: {
    // Video
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    .background {
      position: relative;
      display: flex;
      justify-content: center; /* 水平置中 */
      align-items: center; /* 垂直置中 */
      width: 100vw;
      background-color: blue;
      background: linear-gradient(to bottom, rgb(57, 57, 248) 0%, rgb(94, 92, 252) 100%);
      z-index: 10;
      .background-image {
        position: fixed;
        bottom: 0;
        z-index: -5;
      }
      .cloud-l {
        left: 0;
      }
      .cloud-r {
        right: 0;
      }
    }
    .image-circle {
      position: relative;
      .circle_picture {
        width: 150px;
        height: 150px;
        border-radius:50%;
      }
      .editor {
        right: 0;
        bottom: 0;
        position: absolute;
        border-radius: 5px;
        border: 2px solid rgb(15, 163, 15);
        width: 25px;
        height: 25px;
      }
      .editor:hover {
        -webkit-filter: sepia(50%); /* Safari */
        filter: sepia(50%);
      }
    }
    .book-index {
      margin: 20vh 10vw 10vh 10vw;
      width: 60vw;
      min-height: 80vh;
      border: 10px solid orangered;
      border-radius: 30px;
      background-color: #fff;
      padding: 5vh 5vw;
      .title-book {
        margin: auto;
        width: 50vw;
        padding: 10px;
        min-height: 30vh;
        margin-bottom: 5vh;
        border: 2.5px dashed orangered;
        border-radius: 30px;
        box-shadow: 0px 0px 0px 5px #eee;
        background-color: #eee;
        .studentInfo {
          text-align: left;
          h3 {
            .user-name {
              font-size: 2rem;
              color: rgb(10, 128, 10);
              font-weight: bold;
            }
            .role-text {
              font-size: 1rem;
              color: rgb(95, 95, 95);
            }
          }
          .time-title {
            color: rgb(95, 95, 95);
          }
          .time-text {
            font-weight: bolder;
          }
        }
      }
      .book {
        position: relative;
        .book-frame {
          width: 100%;
        }
        .percentage {
          color: rgb(95, 95, 95);

          font-size: 2rem;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
        .name-box {
          width: 70%;
          position: absolute;
          font-weight: 400;
          top: 12%;
          left: 15%;
          padding: 2px;
          border-radius: 5px;
          background-color: #EFFFDC; /* 底色 */
        }
        .book-name {
          padding: 0;
          margin: 0;
          font-weight: 400;
          line-height: 2.5rem;
          font-size: 1.25rem;
          max-height: 20%;
          color: green;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
        }
        .book-image {
          border: 5px solid #fff;
          width: 60%;
          position:absolute;
          bottom: 20%;
          left: 20%;
        }
        .no-book-image {
          width: 30%;
          position:absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      .book:hover {
        filter: drop-shadow(5px 5px yellow) drop-shadow(5px -5px yellow)
        drop-shadow(-5px 5px yellow) drop-shadow(-5px -5px yellow);
      }
      .book-detail {
        margin: 0;
        padding: 0;
        list-style: none;
        font-size: .8rem;
        label {
          color: #999;
          padding: 0;
          margin: 0;
        }
      }
    }
    @media screen and (max-width: 1480px) {
      .cloud-l {
        display: none;
      }
      .cloud-r {
        display: none;
      }
      .book-index {
        width: 80vw;
      }
    } /*小於700*/
  }

</style>
